import { KliCurrencyField } from './Currency';
import { KliField } from './Field';

// sub-components
KliField.Currency = KliCurrencyField;

export { KliField };
